import axios from 'axios';
import {getSSOClient} from "../main/singleton/sso-client";

const AUTH_API_URL = process.env.REACT_APP_API_URL_AUTHENTICATION as string;

const api = axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
  baseURL: AUTH_API_URL,
});

export const login = async (data) => {
  return api.post('/', data);
}

export const getConsolesByEmail = async (email: string) => {
  const token = await getSSOClient().getToken()

  return api.get(`/Consoles/by-email/${email}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(({ data }) => data?.data)
}

export default api;
